<div [class.bg-violet-100]="aside$ | async" [class.dark:bg-[#252c5f]]="aside$ | async">

  <div class="w-full">

    <div class="mx-auto lg:mx-0 lg:max-w-none flex items-center justify-between border-b border-violet-200/50 dark:border-[#3c4377] p-6">
      <h2 class="text-lg text-secondary dark:text-white font-semibold">Tags</h2>
      <button type="button" (click)="closeAside()" class="hover:opacity-90">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 text-secondary">
          <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
        </svg>
      </button>
    </div>

    <div class="space-y-6 overflow-y-scroll h-[calc(100vh-150px)] scrollbar-thin scrollbar-track-transparent scrollbar-thumb-violet-200 hover:scrollbar-thumb-transparent">

      <div class="space-y-8 p-3 m-3">

        <!-- Always show progress bar and heading -->
        <div @fadeFromRight>
          <!-- Progress bar with inset shadow -->
          <div [ngStyle]="progressBarStyle">
            <!-- Animated fill based on status -->
            <div [ngStyle]="progressBarFillStyle"></div>
          </div>

          <!-- Left-aligned heading -->
          <div class="flex items-start">
            <h2 class="font-semibold" [ngStyle]="investmentStyleHeading">
              {{ investmentLabel || 'Investment Status' }}
            </h2>
          </div>
        </div>

        <!-- My Judgement -->
        <div *ngIf="filterOptions.myJudgement?.length > 0" @fadeFromRight>
          <h2 class="text-sm/6 font-semibold text-secondary dark:text-primary-200 mb-1">My Feelings</h2>
          <app-toggle-button-group
            label="My Judgement"
            [options]="filterOptions.myJudgement"
            [inputType]="'radio'"
            name="myJudgement"
            [selected]="selectedFilters['myJudgement'][0]"
            (selectionChange)="onFilterChange('myJudgement', $event)">
          </app-toggle-button-group>
        </div>

        <!-- Deal Stage -->
        <div *ngIf="filterOptions.dealStages?.length > 0" @fadeFromRight>
          <h2 class="text-sm/6 font-semibold text-secondary dark:text-primary-200 mb-1">Deal Stage</h2>
          <app-toggle-button-group
            label="Deal Stage"
            [options]="filterOptions.dealStages"
            [inputType]="'radio'"
            name="dealStages"
            [selected]="selectedFilters['dealStages'][0]"
            (selectionChange)="onFilterChange('dealStages', $event)">
          </app-toggle-button-group>
        </div>

        <!-- Deal Value -->
        <div *ngIf="filterOptions.dealValues?.length > 0" @fadeFromRight>
          <h2 class="text-sm/6 font-semibold text-secondary dark:text-primary-200 mb-1">Deal Value</h2>
          <app-toggle-button-group
            label="Role"
            [options]="filterOptions.dealValues"
            [inputType]="'radio'"
            name="dealValues"
            [selected]="selectedFilters['dealValues'][0]"
            (selectionChange)="onFilterChange('dealValues', $event)">
          </app-toggle-button-group>
        </div>

      </div>

      <div class="space-y-6 p-6">

        <!-- Roles -->
        <div *ngIf="filterOptions.dealStages?.length > 0" @fadeFromRight>
          <h2 class="text-sm/6 font-semibold text-secondary dark:text-primary-200 mb-1">Roles</h2>
          <app-toggle-button-group
            label="Role"
            [options]="filterOptions.roles"
            [inputType]="'checkbox'"
            name="roles"
            [selected]="selectedFilters['roles']"
            (selectionChange)="onFilterChange('roles', $event)">
          </app-toggle-button-group>
        </div>

        <!-- Status -->
        <div *ngIf="filterOptions.statuses?.length > 0" @fadeFromRight>
          <h2 class="text-sm/6 font-semibold text-secondary dark:text-primary-200 mb-1">Status</h2>
          <app-toggle-button-group
            label="Statuses"
            [options]="filterOptions.statuses"
            [inputType]="'radio'"
            name="statuses"
            [selected]="selectedFilters['statuses'][0]"
            (selectionChange)="onFilterChange('statuses', $event)">
          </app-toggle-button-group>
        </div>

        <!-- Close Dates -->
        <div *ngIf="filterOptions.closeDates?.length > 0" @fadeFromRight>
          <h2 class="text-sm/6 font-semibold text-secondary dark:text-primary-200 mb-1">Close Dates</h2>
          <app-toggle-button-group
            label="Close Dates"
            [options]="filterOptions.closeDates"
            [inputType]="'radio'"
            name="closeDates"
            [selected]="selectedFilters['closeDates'][0]"
            (selectionChange)="onFilterChange('closeDates', $event)">
          </app-toggle-button-group>
        </div>

        <!-- ICP Name -->
        <div *ngIf="filterOptions.icpName?.length > 0" @fadeFromRight>
          <h2 class="text-sm/6 font-semibold text-secondary dark:text-primary-200 mb-1">ICP Name</h2>
          <app-toggle-button-group
            label="ICP Name"
            [options]="filterOptions.icpName"
            [inputType]="'checkbox'"
            name="icpName"
            [selected]="selectedFilters['icpName']"
            (selectionChange)="onFilterChange('icpName', $event)">
          </app-toggle-button-group>
        </div>

      </div>

    </div>

  </div>

</div>
